import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const ShedRepository = RepositoryFactory.get('RailwayRepository')['ShedRepository'];

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(ShedRepository)

export const STORE_MODULE_NAME = 'shed';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
